'use client';

import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SectionHeading } from '@/components/shared/SectionHeading';
import { fadeInUp, staggerContainer } from '@/lib/animations';
import type { AmbassadorContent } from '@/lib/content-schema';

interface Props {
  content: AmbassadorContent['howItWorks'];
}

export function HowItWorksAmbassador({ content }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="como-funciona" className="py-24 md:py-32 bg-zibarit-negro">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading title={content.sectionTitle} dark />

        <motion.div
          ref={ref}
          variants={staggerContainer}
          initial="initial"
          animate={isInView ? 'animate' : 'initial'}
          className="relative max-w-3xl mx-auto"
        >
          {content.steps.map((step, index) => (
            <motion.div
              key={step.number}
              variants={fadeInUp}
              className="relative mb-12 last:mb-0"
            >
              <div className="flex flex-col items-center">
                <div className="text-center mb-6">
                  <h3 className="text-title text-xl md:text-2xl text-zibarit-bone mb-2 uppercase tracking-wide">
                    {step.title}
                  </h3>
                  <p className="text-body text-sm md:text-base text-zibarit-marron-secundario max-w-md mx-auto">
                    {step.description}
                  </p>
                </div>

                {index < content.steps.length - 1 && (
                  <div className="w-px h-16 bg-zibarit-marron-secundario/30 relative mb-6">
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2 h-2 border-r border-b border-zibarit-marron-secundario/50 rotate-45 -mb-1" />
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
